<template>
    <ul
        class="q-search-history"
    >
        <li
            class="history-item"
            v-for="item in historys"
            :key="item"
            @click="() => handleSearchByHistory(item)"
        >
            <i class="time-icon"></i>
            <span>{{item}}</span>
            <i class="close-icon" @click.stop="() => removeHistory(item)"></i>
        </li>
        <li class="clear-all" v-if="historys.length">
            <span @click="() => removeAll()">清除历史记录</span>
        </li>
    </ul>
</template>

<script>
// event
import eventBus from '@/eventBus'

// mixins
import HistoryMixin from '@/mixins/history'

export default {
    name: 'SearchHistory',
    mixins: [HistoryMixin],
    props: {
        show: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            historys: []
        }
    },
    methods: {
        handleSearchByHistory (hi) {
            eventBus.$emit('searchHistory', hi)
        }
    },
    mounted () {
        // this.updateHistorys()
        this.historys = this.getHistorys()
        eventBus.$once('historiesUpdated', (val) => {
            this.historys = val
        })
    }
}
</script>

<style lang="less" scoped>
.q-search-history {
    padding: 10px;
    .history-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 10px 2px;
        color: rgba(74, 74, 74, 0.70);
        i {
            display: block;
        }
        .time-icon {
            background: url(../assets/time.png) no-repeat center;
            width: 16px;
            height: 16px;
            background-size: 12px 12px;
        }
        .close-icon {
            background: url(../assets/close-bolder.png) no-repeat center;
            width: 15px;
            height: 15px;
            background-size: 9px 9px;
        }
        span {
            flex: 1;
            font-size: 14px;
            line-height: 20px;
            text-align: left;
            margin: 0 20px;
        }
    }
    .clear-all {
        font-size: 14px;
        line-height: 20px;
        color: rgba(74, 74, 74, 0.40);
        text-align: left;
        margin-top: 10px;
        span {
            margin-left: 35px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/SearchHistory.vue